module.exports = __webpack_public_path__ + "assets/img/onboarding_3.7c3db97b.png";